import { api } from '../serverClient';

export async function fetchListings({ cardId, search, sortBy, sortOrder, limit, offset } = {}) {
  const params = new URLSearchParams();
  if (cardId) params.set('cardId', cardId);
  if (search) params.set('search', search);
  if (sortBy) params.set('sortBy', sortBy);
  if (sortOrder) params.set('sortOrder', sortOrder);
  if (limit != null) params.set('limit', limit);
  if (offset != null) params.set('offset', offset);
  const query = params.toString();
  return api.get(`/auction/listings${query ? `?${query}` : ''}`);
}

export async function fetchMyListings() {
  return api.get('/auction/my-listings');
}

export async function createListing(_token, cardId, cardName, price, artGroup, foiling, options = {}) {
  // options.auctionType: 'fixed' (default) | 'timed'
  // options.durationHours: 12 | 24 | 48 | 72  (timed only)
  // options.startingBid: integer  (timed only)
  // options.buyoutPrice: integer  (timed only. Optional Buy It Now
  //   alongside the bidding flow; must be > startingBid).
  return api.post('/auction/list', {
    cardId,
    cardName,
    price,
    artGroup: artGroup || 'base',
    foiling: foiling || 'S',
    auctionType: options.auctionType || 'fixed',
    durationHours: options.durationHours,
    startingBid: options.startingBid,
    buyoutPrice: options.buyoutPrice ?? null,
  });
}

// Place a bid on a timed auction. The server debits the bidder's
// coins immediately and refunds previous top bidders via mail.
export async function placeBid(_token, listingId, amount) {
  return api.post('/auction/bid', { listingId, amount });
}

export async function buyListing(_token, listingId) {
  return api.post('/auction/buy', { listingId });
}

export async function cancelListing(_token, listingId) {
  return api.post('/auction/cancel', { listingId });
}

// Returns the seller's effective Reliquarian benefits as the server
// sees them: { capacity, active, feePercent }. Used to drive the
// "X / N listings used" + fee preview in the Sell tab. The numbers
// also mirror the client-side getMerchant*() helpers; we still
// fetch from the server so a stale cache or skipped sync can't lie
// about a player's true cap.
export async function fetchMyAuctionLimits() {
  return api.get('/auction/my-limits');
}
